import { GridRenderCellParams } from '@mui/x-data-grid';
import { DataTableProps } from 'components/data/DataTable/DataTable';
import { Sparkline } from 'components/data/Sparklines/Sparkline';
import { getObjectValueByPath } from 'helpers/general';
import { Device, DeviceLastReading } from 'types';
import { TankLevelIndicator } from 'components/data/TankLevelIndicator/TankLevelIndicator';
import { getMonthDayYear } from 'helpers/dates';

export const devicePanelViewColumns: DataTableProps['columns'] = [
    {
        headerName: 'Tank Level',
        field: 'lastReading.tank',
        flex: 1,
        renderCell: (
            params: GridRenderCellParams<{
                gallons: Device['gallons'];
                tankLevelPercentage: DeviceLastReading['tank'];
            }>
        ) => {
            return (
                <TankLevelIndicator
                    tankLevelPercentage={params.value?.tankLevelPercentage}
                    gallons={params.value?.gallons}
                />
            );
        },
        valueGetter: (params) => {
            const gallons = getObjectValueByPath(params.row, 'gallons');
            const tankLevelPercentage = getObjectValueByPath(
                params.row,
                'lastReading.tank'
            );

            return { gallons, tankLevelPercentage };
        },
    },
    {
        headerName: 'Customer Name',
        field: 'customer_name',
        valueGetter: (params) => {
            if (params.value) return params.value;
            return `Device ID: ${params.row.shortDeviceId}`;
        },
    },
    {
        headerName: 'Address',
        field: 'address',
        valueGetter: (params) => {
            if (params.value) return params.value;
            return 'No Address Entered';
        },
    },
    {
        headerName: '30 Day Sparkline',
        field: 'l30',
        disableExport: true,
        renderCell: (params) => {
            const data = params.value ? params.value.split(',') : [];
            return <Sparkline data={data} />;
        },
    },
    {
        headerName: 'Estimated Delivery Date',
        field: 'duf_7',
        valueFormatter(params) {
            return params.value ? getMonthDayYear(params.value) : null;
        },
    },
];
